"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Ref, Component, PropSync } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import _ from "lodash";
import draggable from "vuedraggable";
import { Debounce } from "vue-debounce-decorator";
let HeaderOperate = class extends Vue {
  constructor() {
    super(...arguments);
    this.columnsList = [];
    this.waiting = false;
    this.dialog = new UiDialogController();
  }
  created() {
    var _a;
    for (const _column of this._columns.currentView()) {
      if (this._columns.get(_column.name)) {
        const _itemColumn = {
          label: (_a = this._columns.get(_column.name)) == null ? void 0 : _a.label,
          name: _column.name,
          visible: _column.visible
        };
        this.columnsList.push(_itemColumn);
      }
    }
  }
  customColumDialog() {
    this._customColumnsDialog.show();
  }
  cancel() {
    this._customColumnsDialog.close();
  }
  confirm() {
    _.remove(this.columnsList, { name: "name" });
    _.remove(this.columnsList, { name: "operation" });
    this.columnsList.unshift({
      name: "name",
      visible: true
    });
    this.columnsList.push({
      name: "operation",
      visible: true
    });
    localStorage.setItem(this._storage, JSON.stringify(this.columnsList));
    this._columns.views(this.columnsList);
    this._controller.search();
    this._customColumnsDialog.close();
  }
  changeColums() {
    const _sort = this.columnsList;
  }
  checkMove(event) {
    this.changeColums();
  }
};
__decorateClass([
  Ref("custom-columns")
], HeaderOperate.prototype, "_customColumnsDialog", 2);
__decorateClass([
  PropSync("storage")
], HeaderOperate.prototype, "_storage", 2);
__decorateClass([
  PropSync("controller")
], HeaderOperate.prototype, "_controller", 2);
__decorateClass([
  PropSync("columns")
], HeaderOperate.prototype, "_columns", 2);
__decorateClass([
  Debounce(800)
], HeaderOperate.prototype, "changeColums", 1);
HeaderOperate = __decorateClass([
  Component({
    components: {
      UiDialog,
      draggable
    }
  })
], HeaderOperate);
export {
  HeaderOperate as default
};
